export const AccompagnementSanitaire = [
  {
    id: 1,
    title: "Diagnostic de l'existant",
    body: "État des lieux et établissement du plan d'actions",
    img: "./static/svg/OurJobs/diagnostic_existant.svg",
  },
  {
    id: 2,
    title: "Sensibilisation et formation",
    body: "Sensibilisation et formation des collaborateurs aux exigences du référentiel et au plan d'actions",
    img: "./static/svg/OurJobs/plan.svg",
  },
  {
    id: 3,
    title: "Mise en place du Système de Management",
    body: "Mise en place du plan de reprise, du système documentaire, des pratiques, des mesures et des infrastructures nécessaires.",
    img: "./static/svg/OurJobs/system_management.svg",
  },
  {
    id: 4,
    title: "Évaluation interne",
    body: "Évaluation de la conformité et l'efficacité des pratiques et des mesures mises en place",
    img: "./static/svg/OurJobs/evaluation_interne.svg",
  },
  {
    id: 5,
    title: "Audit de certification",
    body: "Évaluation externe du système de management des risques sanitaires et obtention de la certification par : SOCOTEC Certification International",
    img: "./static/svg/OurJobs/audit_certificate.svg",
  },
];

export const AccompagnementQHSE = [
  {
    name: "ISO 9001 v2015",
  },
  {
    name: "ISO 14001 v2015",
  },
  {
    name: "ISO 45001 v2015",
  },

  {
    name: "ISO 50001 v2018",
  },
  {
    name: "ISO 27001 v2018",
  },
];

export const AccompagnementQHSE2 = [
  {
    name: "Analyse environnementale",
  },
  {
    name: "Étude d'impact sur l'environnement",
  },
  {
    name: "Étude d'impact sur l'environnement",
  },
  {
    name: "Étude des installations incendie",
  },
  {
    name: "Analyse des risques SST",
  },
];

export const AuditQHSE = [
  {
    name: "ISO 9001 /14001/ 45001 / 22000 / 50001 ...",
  },
  {
    name: "SSE chantiers",
  },
  {
    name: "Hygiène alimentaire",
  },
  {
    name: "Légal & Règlementaire QSE",
  },
  {
    name: "Labellisation",
  },
  {
    name: "Client mystère",
  },
  {
    name: "Fournisseurs",
  },
  {
    name: "Documentaire",
  },
];

export const FormationQHSE = [
  {
    name: "Systèmes de Management",
  },
  {
    name: "Qualité",
  },
  {
    name: "Sécurité",
  },
  {
    name: "Environnement",
  },
  {
    name: "Efficacité énergétique",
  },
  {
    name: "Hygiène alimentaire",
  },
  {
    name: "Légal & Réglementaire",
  },
  {
    name: "Risques",
  },
];

export const IngenierieQHSE = [
  {
    name: "Diagnostic stratégique",
  },
  {
    name: "Ingénierie de formation",
  },
  {
    name: "Accompagnement à la certification QSE",
  },
  {
    name: "Accompagnement organisationnel",
  },
];
